<h2 mat-dialog-title>Nuevo examen desde plantilla</h2>

<mat-dialog-content [formGroup]="form">
  <mat-form-field class="full-width">
    <mat-label>Plantilla</mat-label>
    <mat-select formControlName="exam_template_id">
      @for (exam_template of exam_templates(); track exam_template.id) {
        <mat-option [value]="exam_template.id">{{ exam_template.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Nombre del examen (opcional)</mat-label>
    <input matInput formControlName="name" />
    <mat-hint>Si lo dejas vacío, se usará el nombre de la plantilla.</mat-hint>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancelar</button>
  <button mat-flat-button color="accent" type="button" [disabled]="loading() || form.invalid" (click)="save()">Crear examen</button>
</mat-dialog-actions>
